export function formatPhoneNumber(phoneNumber:string) {
    const regex = /^90(\d{3})(\d{3})(\d{4})$/;
    return phoneNumber.replace(regex, "+90($1) $2$3");
}